import ApiInfo from './ApiInfo.js';

class SalesApiInfo extends ApiInfo {
  // 声明接口类
  constructor({
    path,
    type = 'get',
    timeout = 30000,
    headers,
    project = 'sales-crm',
    author = '未定义',
  }) {
    super({
      path,
      type,
      timeout,
      headers,
      project,
      author,
    });
  }
}

export default {
  common: {
    // 搜索可绑定账户的接口
    searchBindableAcc: new SalesApiInfo({
      path: '/admin/account/search-bind',
      type: 'post',
      author: '易怀源',
    }),
    // 客户列表 done
    customerList: new SalesApiInfo({
      path: '/admin/customer/get-list',
      type: 'post',
      author: '易怀源',
    }),
    // 广告主或子账户列表
    userList: new SalesApiInfo({
      path: '/admin/account/search-adv-user',
      type: 'post',
      author: '杜伟',
    }),
    // 查询产品详细信息的接口
    prodDetail: new SalesApiInfo({
      path: '/admin/product/read',
      type: 'post',
      author: '易怀源',
    }),
    // 修改合作产品接口 done
    updateProd: new SalesApiInfo({
      path: '/admin/customer/update-product',
      type: 'post',
      author: '易怀源',
    }),
    // 删除客户的接口 done
    delCustomer: new SalesApiInfo({
      path: '/admin/customer/delete-customer',
      type: 'post',
      author: '易怀源',
    }),
    // 客户详情接口
    customerDetail: new SalesApiInfo({
      path: '/admin/customer/get-product-and-account',
      type: 'post',
      author: '易怀源',
    }),
    // 客户详情接口
    customerDetail2: new SalesApiInfo({
      path: '/admin/customer/get-product',
      type: 'post',
      author: '付豪',
    }),
    // 客户详情接口
    getProductAccount: new SalesApiInfo({
      path: '/admin/customer/get-product-account',
      type: 'post',
      author: '付豪',
    }),
    // 客户详情接口
    getProductByCustomer: new SalesApiInfo({
      path: '/admin/customer/get-product-by-customer',
      type: 'post',
      author: '杜伟',
    }),
    // 客户详情接口
    getAccountPosition: new SalesApiInfo({
      path: '/admin/customer/get-account-position',
      type: 'post',
      author: '付豪',
    }),
    // 修改销售接口
    updateSales: new SalesApiInfo({
      path: '/admin/product/update-sales',
      type: 'post',
      author: '易怀源',
    }),
    // 修改绑定销售
    updateCustomerSales: new SalesApiInfo({
      path: '/admin/product/update-customer-sales',
      type: 'post',
      author: '杜伟',
    }),
    // 修改运营接口
    updateBusiness: new SalesApiInfo({
      path: '/admin/product/update-operations',
      type: 'post',
      author: '徐佳楠',
    }),
    // 关联ADV账户接口 done
    bindADV: new SalesApiInfo({
      path: '/admin/product/bind-account',
      type: 'post',
      author: '易怀源',
    }),
    // （解除|绑定）销售归属关系
    updateSalesType: new SalesApiInfo({
      path: '/admin/account/update-sales-type',
      type: 'post',
      author: '易怀源',
    }),
    // 批量（解除|绑定）销售归属关系
    batchUpdateSalesType: new SalesApiInfo({
      path: '/admin/account/batch-update-sales-type',
      type: 'post',
      author: '郭留永',
    }),
    // 解绑产品关系
    unbindProd: new SalesApiInfo({
      path: '/admin/account/unbind-product',
      type: 'post',
      author: '易怀源',
    }),
    // 关联产品
    bindProd: new SalesApiInfo({
      path: '/admin/account/bind-product',
      type: 'post',
      author: '易怀源',
    }),
    // 修改产品关系
    undateBindProd: new SalesApiInfo({
      path: '/admin/account/update-binding-product',
      type: 'post',
      author: '郭留永',
    }),
    // 查询销售接口 done
    sales: new SalesApiInfo({
      path: '/admin/user/get-list',
      type: 'post',
      author: '易怀源',
    }),
    // 修改公司名接口 done
    updateCompany: new SalesApiInfo({
      path: '/admin/customer/update-company',
      type: 'post',
      author: '易怀源',
    }),
    // 匹配公司
    searchCompany: new SalesApiInfo({
      path: '/admin/customer/search-customer',
      type: 'post',
      author: '易怀源',
    }),
    // ADV修改主体
    updateAdvCustomer: new SalesApiInfo({
      path: '/admin/account/update-customer',
      type: 'post',
      author: '易怀源',
    }),

    // ADV产品列表 查询
    getAdvProd: new SalesApiInfo({
      path: '/admin/account/get-list',
      type: 'post',
      author: '易怀源',
    }),
    // ADV产品列表 同步
    syncAdvProd: new SalesApiInfo({
      path: '/admin/account/sync-product',
      type: 'post',
      author: '易怀源',
    }),
    // ADV产品 搜索
    searchProd: new SalesApiInfo({
      path: '/admin/product/search-products',
      type: 'get',
      author: '郭留永',
    }),
    // 暂不处理
    stopProduct: new SalesApiInfo({
      path: '/admin/account/hang-product',
      type: 'post',
      author: '郭留永',
    }),
    // 更新服务代理情况
    updateAgentInfo: new SalesApiInfo({
      path: '/admin/account/update-agent',
      type: 'post',
      author: '周超',
    }),
    // 更新任务绑定
    updateTask: new SalesApiInfo({
      path: '/admin/account/update-task',
      type: 'post',
      author: '杜伟',
    }),
    // 更新任务绑定
    updateTaskId: new SalesApiInfo({
      path: '/admin/account/update-task-id',
      type: 'post',
      author: '王晓阳',
    }),
    // 更新预算类型
    updateBudgetType: new SalesApiInfo({
      path: '/admin/account/update-sale-type',
      type: 'post',
      author: '王晓阳',
    }),
  },

  budget: {
    list: new SalesApiInfo({
      path: '/budget/budget/list',
      type: 'post',
      author: '杜伟',
    }),
    add: new SalesApiInfo({
      path: '/budget/budget/add',
      type: 'post',
      author: '杜伟',
    }),
    update: new SalesApiInfo({
      path: '/budget/budget/update',
      type: 'post',
      author: '杜伟',
    }),
    batchUpdate: new SalesApiInfo({
      path: '/budget/budget/batch-update',
      type: 'post',
      author: '杜伟',
    }),
    detail: new SalesApiInfo({
      path: '/budget/budget/detail',
      type: 'post',
      author: '杜伟',
    }),
    review: new SalesApiInfo({
      path: '/budget/budget/review',
      type: 'post',
      author: '杜伟',
    }),
    log: new SalesApiInfo({
      path: '/budget/budget/log',
      type: 'post',
      author: '杜伟',
    }),
  },
  // 聚合预算绑定
  budgetBind: {
    list: new SalesApiInfo({
      path: '/budget/budget/budget-list',
      type: 'post',
      author: '杜伟',
    }),
    add: new SalesApiInfo({
      path: '/budget/budget/budget-add',
      type: 'post',
      author: '杜伟',
    }),
    update: new SalesApiInfo({
      path: '/budget/budget/budget-update',
      type: 'post',
      author: '杜伟',
    }),
    detail: new SalesApiInfo({
      path: '/budget/budget/detail',
      type: 'post',
      author: '杜伟',
    }),
    review: new SalesApiInfo({
      path: '/budget/budget/budget-review',
      type: 'post',
      author: '杜伟',
    }),
    log: new SalesApiInfo({
      path: '/budget/budget/log',
      type: 'post',
      author: '杜伟',
    }),
    download: new SalesApiInfo({
      path: '/budget/budget/budget-download',
      type: 'post',
      author: '杜伟',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    batchBind: new SalesApiInfo({
      path: '/budget/budget/budget-batch-bind-sale',
      type: 'post',
      author: '杜伟',
    }),
    assign: new SalesApiInfo({
      path: '/budget/budget/budget-robot',
      type: 'post',
      author: '杜伟',
    }),
  },
  aggregation: {
    list: new SalesApiInfo({
      path: '/budget/budget/budget-list',
      type: 'post',
      author: '杜伟',
    }),
    add: new SalesApiInfo({
      path: '/budget/budget/budget-add',
      type: 'post',
      author: '杜伟',
    }),
    update: new SalesApiInfo({
      path: '/budget/budget/budget-update',
      type: 'post',
      author: '杜伟',
    }),
    unbind: new SalesApiInfo({
      path: '/budget/budget/budget-unbind-sale',
      type: 'post',
      author: '杜伟',
    }),
    transfer: new SalesApiInfo({
      path: '/budget/budget/budget-transfer-sale',
      type: 'post',
      author: '杜伟',
    }),
    batchUnbind: new SalesApiInfo({
      path: '/budget/budget/budget-batch-unbind-sale',
      type: 'post',
      author: '杜伟',
    }),
    batchTransfer: new SalesApiInfo({
      path: '/budget/budget/budget-batch-transfer-sale',
      type: 'post',
      author: '杜伟',
    }),
    claim: new SalesApiInfo({
      path: '/budget/budget/budget-group-claim',
      type: 'post',
      author: '杜伟',
    }),
    groupList: new SalesApiInfo({
      path: '/budget/budget/budget-group-list',
      type: 'post',
      author: '杜伟',
    }),
    budgetExpire: new SalesApiInfo({
      // path: '/budget/budget/budget-group-list',
      path: '/budget/budget/budget-expire',
      type: 'post',
      author: '杜伟',
    }),
    noticeList: new SalesApiInfo({
      path: '/budget/budget/formula-query',
      type: 'get',
      author: '杜伟',
    }),
    customerReviewList: new SalesApiInfo({
      path: '/budget/budget/protect-audit-list',
      type: 'get',
      author: '杜伟',
    }),
    customerReviewLogList: new SalesApiInfo({
      path: '/budget/budget/protect-audit-log',
      type: 'get',
      author: '杜伟',
    }),
    customerReviewDetail: new SalesApiInfo({
      path: '/budget/budget/protect-audit-detail',
      type: 'get',
      author: '杜伟',
    }),
    protectAuditReview: new SalesApiInfo({
      path: '/budget/budget/protect-audit-review',
      type: 'post',
      author: '杜伟',
    }),
    protectAuditAdjust: new SalesApiInfo({
      path: '/budget/budget/protect-audit-adjust',
      type: 'post',
      author: '杜伟',
    }),
    reviewResult: new SalesApiInfo({
      path: '/budget/budget/protect-audit-result',
      type: 'get',
      author: '杜伟',
    }),
    
  },
  // 产品系
  productSeries: {
    aggregations: new SalesApiInfo({
      path: '/budget/budget/budget-list',
      type: 'get',
      author: '杜伟',
    }),
    products: new SalesApiInfo({
      path: '/product/read',
      type: 'get',
      author: '杜伟',
    }),
    products2: new SalesApiInfo({
      path: '/product/read',
      type: 'post',
      author: '杜伟',
    }),
    sales: new SalesApiInfo({
      path: '/admin/user/get-list',
      type: 'get',
      author: '杜伟',
    }),
    list: new SalesApiInfo({
      path: '/series/list',
      type: 'get',
      author: '王晓阳',
    }),
    allList: new SalesApiInfo({
      path: '/series-all/list',
      type: 'get',
      author: '王晓阳',
    }),
    add: new SalesApiInfo({
      path: '/series/add',
      type: 'post',
      author: '王晓阳',
    }),
    update: new SalesApiInfo({
      path: '/series/update',
      type: 'post',
      author: '王晓阳',
    }),
    updateAggregation: new SalesApiInfo({
      path: '/series/update-budget',
      type: 'post',
      author: '王晓阳',
    }),
    updateProduct: new SalesApiInfo({
      path: '/series/update-product',
      type: 'post',
      author: '王晓阳',
    }),
    // 查询产品详细信息的接口
    productDetail: new SalesApiInfo({
      path: '/product/basic-search-list',
      type: 'get',
      author: '易怀源',
    }),
    // 查询产品详细信息的接口
    productSeriesAll: new SalesApiInfo({
      path: '/series-all/product-list',
      type: 'get',
      author: '杜伟',
    }),
    // 查询产品详细信息的接口
    budgetDetail: new SalesApiInfo({
      path: '/budget/budget/basic-search-list',
      type: 'get',
      author: '易怀源',
    }),
    // 所有产品系
    listAll: new SalesApiInfo({
      path: '/series-all/list',
      type: 'get',
      author: '杜伟',
    }),
    addAll: new SalesApiInfo({
      path: '/series-all/add',
      type: 'post',
      author: '杜伟',
    }),
    updateAll: new SalesApiInfo({
      path: '/series-all/update',
      type: 'post',
      author: '杜伟',
    }),
    updateProductAll: new SalesApiInfo({
      path: '/series-all/update-product',
      type: 'post',
      author: '杜伟',
    }),
  },
  // 任务标签
  taskTag: {
    list: new SalesApiInfo({
      path: '/tasks/list',
      type: 'get',
      author: '王晓阳',
    }),
    add: new SalesApiInfo({
      path: '/tasks/add',
      type: 'post',
      author: '王晓阳',
    }),
    updateAggregation: new SalesApiInfo({
      path: '/tasks/update-budget',
      type: 'post',
      author: '王晓阳',
    }),
    updateProduct: new SalesApiInfo({
      path: '/tasks/update-product',
      type: 'post',
      author: '王晓阳',
    }),
    // 查询产品详细信息的接口
    productDetail: new SalesApiInfo({
      path: '/product/basic-search-list',
      type: 'get',
      author: '易怀源',
    }),
    // 查询产品详细信息的接口
    budgetDetail: new SalesApiInfo({
      path: '/budget/budget/basic-search-list',
      type: 'get',
      author: '易怀源',
    }),
  },

  // 产品运营关系
  productOperate: {
    list: new SalesApiInfo({
      path: '/operation/product-relation',
      type: 'get',
      author: '李乙',
    }),
  },
};
